import { render, staticRenderFns } from "./UserUpload.vue?vue&type=template&id=19e37ad1&scoped=true&"
import script from "./UserUpload.vue?vue&type=script&lang=js&"
export * from "./UserUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19e37ad1",
  null
  
)

export default component.exports